export const initialState = {
  formData: {
    headOfficeInfosInputs: {
      headOfficeTurnover: "",
      headOfficeWorkforce: "",
      headOfficeLegalForm: "",
      headOfficeCsp: "",
      quotationType: "",
      qualityApplicant: "",
    },
    globalInfosInputs: {
      turnover: "",
      workforce: "",
    },
    activiteInputs: {
      activitesPro: [],
      secteursPro: [],
    },
    rcproGlobalInfoInputs: {
      principauxClients: [],
      appelSousTraitants: "",
      pourcentageSousTraite: "",
      imposeRCSousTraitants: "",
    },

    rcproSpecificInfoInputs: {
      conseilTypeConseils: [],
      conseilRecommandationsAppliqueesParClient: "",
      informatiqueActivitePrincipale: [],
      informatiqueInterventionCritique: "",
      marketingContenuPublic: "",
      marketingDroitUtilisationVerifie: "",
      educationTypeFormation: [],
      educationFormationCertifiante: "",
      educationCertifieQualiopi: "",
      restaurationTypeRestauration: [],
      restaurationRespectHACCP: "",
      commerceAlimentaireModaliteVente: [],
      commerceAlimentaireProduitFrais: "",
      habillementProduitsFabriquesOuRevendus: "",
      habillementTracabiliteMatieresPremieres: "",
      santeEmploiPersonnelMedical: "",
      santeActesSousAutorisation: "",
      santeConventionOrganismesSante: "",
      hygieneTypePrestations: [],
      hygieneCosmetiquesSousCertification: "",
      hygieneEmploiPersonnelMedical: "",
      hygieneActesSousAutorisation: "",
      cultureOrganisationEvenements: "",
      cultureAssuranceEvenements: "",
      droitTypeExercice: "",
      droitAutreExercice: "",
      securiteTypesActivites: [],
      securiteAgentsArmes: "",
      securiteTelesurveillance: "",
      bureauTypeActivite: [],
      bureauAutreActivite: "",
      bureauUtilisationLogiciels: "",
      servicesEntreprisesNatureService: [],
      servicesEntreprisesAutreActivite: "",
      servicesEntreprisesInterventionChezClient: "",
      servicesPersonnePrestationsProposees: [],
      servicesPersonneAutrePrestation: "",
      servicesPersonneAgrementSpecifique: "",
      autresCommercesTypeCommerce: [],
      autresCommercesAutreTypeCommerce: "",
      autresCommercesLocalPhysique: "",
      autresServicesNatureServices: [],
      autresServicesAutreNatureServices: "",
      autresServicesDeplacementsFrequents: "",
      autresServicesProfessionReglementee: "",

      conseilPrestationsInternationales: "",
      conseilPrestationsInternationalesZones: [],
      conseilPourcentageCAInternational: "",
      informatiquePrestationsInternationales: "",
      informatiquePrestationsInternationalesZones: [],
      informatiquePourcentageCAInternational: "",
      marketingPrestationsInternationales: "",
      marketingPrestationsInternationalesZones: [],
      marketingPourcentageCAInternational: "",
      culturePrestationsInternationales: "",
      culturePrestationsInternationalesZones: [],
      culturePourcentageCAInternational: "",
      commerceAlimentairePrestationsInternationales: "",
      commerceAlimentairePrestationsInternationalesZones: [],
      commerceAlimentairePourcentageCAInternational: "",
      habillementPrestationsInternationales: "",
      habillementPrestationsInternationalesZones: [],
      habillementPourcentageCAInternational: "",
      autresCommercesPrestationsInternationales: "",
      autresCommercesPrestationsInternationalesZones: [],
      autresCommercesPourcentageCAInternational: "",
      droitPrestationsInternationales: "",
      droitPrestationsInternationalesZones: [],
      droitPourcentageCAInternational: "",
      servicesEntreprisesPrestationsInternationales: "",
      servicesEntreprisesPrestationsInternationalesZones: [],
      servicesEntreprisesPourcentageCAInternational: "",
    },
    rcproGlobalInfo2Inputs: {
      possedeUneRC: "",
      resilieParAssureur: "",
      changementProchainActivite: "",
      dateNaissanceDirigeant: "",
    },
    rcproCommentInputs: {
      commentaireRcpro: "",
    },
  },
  isSaving: false,
  isSaved: false,
  isLoaded: false,
  apiData: null,
  errors: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "RESET_FORM_DATA":
      return initialState;
    case "UPDATE_FORM_DATA":
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
        isLoaded: true,
      };
    case "UPDATE_SAVING":
      return {
        ...state,
        isSaving: action.payload,
        isSaved: !action.payload,
      };
    case "UPDATE_API_DATA":
      return {
        ...state,
        apiData: { ...state.apiData, ...action.payload },
      };
    case "UPDATE_HEADOFFICE_INFOS_INPUTS":
      return {
        ...state,
        formData: {
          ...state.formData,
          headOfficeInfosInputs: {
            ...state.formData.headOfficeInfosInputs,
            ...action.payload,
          },
        },
      };
    case "UPDATE_GLOBAL_INFOS_INPUTS":
      return {
        ...state,
        formData: {
          ...state.formData,
          globalInfosInputs: {
            ...state.formData.globalInfosInputs,
            ...action.payload,
          },
        },
      };
    case "UPDATE_ACTIVITE_INPUTS":
      return {
        ...state,
        formData: {
          ...state.formData,
          activiteInputs: {
            ...state.formData.activiteInputs,
            ...action.payload,
          },
        },
      };

    case "UPDATE_RCPRO_GLOBAL_INFO_INPUTS":
      return {
        ...state,
        formData: {
          ...state.formData,
          rcproGlobalInfoInputs: {
            ...state.formData.rcproGlobalInfoInputs,
            ...action.payload,
          },
        },
      };

    case "UPDATE_RCPRO_SPECIFIC_INFO_INPUTS":
      return {
        ...state,
        formData: {
          ...state.formData,
          rcproSpecificInfoInputs: {
            ...state.formData.rcproSpecificInfoInputs,
            ...action.payload,
          },
        },
      };

    case "UPDATE_RCPRO_GLOBAL_INFO2_INPUTS":
      return {
        ...state,
        formData: {
          ...state.formData,
          rcproGlobalInfo2Inputs: {
            ...state.formData.rcproGlobalInfo2Inputs,
            ...action.payload,
          },
        },
      };

    case "UPDATE_RCPRO_COMMENT_INPUTS":
      return {
        ...state,
        formData: {
          ...state.formData,
          rcproCommentInputs: {
            ...state.formData.rcproCommentInputs,
            ...action.payload,
          },
        },
      };

    case "UPDATE_ERRORS":
      return {
        ...state,
        errors: { ...action.payload },
      };

    default:
      return state;
  }
}
